<!--https://github.com/mengxiong10/vue2-datepicker-->

<template>
    <DatePicker
        ref="datePicker"
        v-bind="$attrs"
        :value="value"
        :lang="lang"
        :disabled-date="disabledDate"
        range-separator=" - "
        @input="input"
        @pick="change"
        @close="close"
    >
        <template #sidebar="{emit}" v-if="$attrs.range">
            <ul class="btn-list">
                <li
                    v-for="(item, ind) of shortcuts"
                    :key="ind"
                    :class="{'active': activeShortcuts(item)}"
                    @click="item.onClick(emit)"
                >{{ item.text }}</li>
            </ul>
        </template>

        <template #footer v-if="$attrs.confirm">
            <vs-button
                class="m-2"
                color="primary"
                @click="apply"
                type="filled"
                size="small"
            >
                {{ $t('calendar.Apply') }}
            </vs-button>
        </template>
    </DatePicker>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
    name: 'v-date-picker',

    props: {
        value: {
            type: [Array, String],
        },
    },

    model: {
        prop: 'value',
        event: 'select'
    },

    data() {
        return {
            disableDates: false,
            lang: {
                formatLocale: {
                    monthsShort: [],
                    weekdaysMin: []
                }
            }
        }
    },

    components: {
        DatePicker
    },

    computed: {
        shortcuts() {
            return [
                {
                    text: this.$t(`calendar.sidebar.today`),
                    onClick: (emit) => {
                        const date = new Date()
                        const _date = [date, date]

                        if (emit) emit(_date)

                        return _date
                    }
                },
                {
                    text: this.$t(`calendar.sidebar.yesterday`),
                    onClick: (emit) => {
                        const date = new Date()
                        date.setTime(new Date().getTime() - 3600 * 1000 * 24)
                        const _date = [date, date]

                        if (emit) emit(_date)

                        return _date
                    }
                },
                {
                    text: this.$t(`calendar.sidebar.this_month`),
                    onClick: (emit) => {
                        const date = new Date()
                        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
                        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
                        const _date = [firstDay, lastDay]

                        if (emit) emit(_date)

                        return _date
                    }
                },
                {
                    text: this.$t(`calendar.sidebar.last_month`),
                    onClick: (emit) => {
                        const date = new Date()
                        const firstMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1)
                        const lastMonth = new Date(date.getFullYear(), date.getMonth(), 0)
                        const _date = [firstMonth, lastMonth]

                        if (emit) emit(_date)

                        return _date
                    }
                },
            ]
        },
    },

    watch: {
        '$i18n.locale': {
            handler() {
                this.monthsShort()
                this.weekdaysMin()
            },
            immediate: true
        }
    },

    methods: {
        monthsShort() {
            const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            this.lang.formatLocale.monthsShort = monthsShort.map(month => this.$t(`calendar.monthNames_short.${month}`))
        },

        weekdaysMin() {
            const weeks = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
            this.lang.formatLocale.weekdaysMin = weeks.map(week => this.$t(`calendar.weekdaysMin.${week}`))
        },

        parseDateToString(date) {
            return `${date[0].toLocaleDateString('ru')}-${date[1].toLocaleDateString('ru')}`
        },

        activeShortcuts(data) {
            if (!this.$refs.datePicker || !Array.isArray(this.$refs.datePicker.currentValue) || !this.$refs.datePicker.currentValue.length) {
                return false
            }

            const selectedDatesString = this.parseDateToString(this.$refs.datePicker.currentValue.map(item => new Date(item)))
            const shortcutDateString = this.parseDateToString(data.onClick())

            return shortcutDateString === selectedDatesString
        },

        cancel() {
            this.$refs.datePicker.closePopup()
        },

        input(event) {
            this.$emit('select', event)
        },

        apply() {
            this.$emit('apply', this.$refs.datePicker.currentValue)
            this.cancel()
        },

        disabledDate(date, currentValue) {
            if(this.disableDates) {
                let a = new Date(currentValue[0])
                return date < a.setMonth(a.getMonth() - 3) || date > a.setMonth(a.getMonth() + 6)
            }
        },

        change() {
            this.disableDates = !this.disableDates
        },

        close() {
            this.disableDates = false
        }
    }
}
</script>

<style lang="scss">
.btn-list {
    li {
        padding: 8px 12px;
        cursor: pointer;
        font-size: 12px;

        &:hover {
            background-color: #f3f9fe;
        }

        &.active {
            background-color: rgba(var(--vs-primary), 1) !important;
            color: white;
        }
    }
}

.mx-datepicker-btn-confirm {
    display: none;
}

</style>
